import { lookupCard } from "../../content/index.js";
import type { CardInstanceId, RunState } from "../types/index.js";
import { createCardInstance } from "../deck/createInstance.js";

function isHandWorker(run: RunState, id: CardInstanceId): boolean {
  const card = run.hand.find((item) => item.instanceId === id);
  return Boolean(card && lookupCard(card.cardId)?.type === "worker");
}

export function toggleSendoff(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "sendoff") return null;
  if (!isHandWorker(run, id)) return null;
  const selected = pending.selected[0] === id ? [] : [id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveSendoff(run: RunState): RunState {
  const pending = run.pendingChoice;
  if (pending?.kind !== "sendoff") return { ...run, pendingChoice: null };
  const id = pending.selected[0];
  if (!id || !isHandWorker(run, id)) return { ...run, pendingChoice: null };
  return {
    ...run,
    hand: run.hand.filter((card) => card.instanceId !== id),
    pendingChoice: null,
  };
}

function isTrainableWorker(run: RunState, id: CardInstanceId): boolean {
  const card = run.hand.find((item) => item.instanceId === id);
  return card?.cardId === "intern" || card?.cardId === "mid";
}

export function toggleTraining(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "training" || !isTrainableWorker(run, id)) return null;
  const selected = pending.selected[0] === id ? [] : [id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveTraining(run: RunState): RunState {
  const pending = run.pendingChoice;
  const id = pending?.kind === "training" ? pending.selected[0] : undefined;
  if (!id || !isTrainableWorker(run, id)) return { ...run, pendingChoice: null };
  const trainee = run.hand.find((card) => card.instanceId === id)!;
  const promotedId = trainee.cardId === "intern" ? "mid" : "senior";
  const created = createCardInstance({ nextCardSequence: run.nextCardSequence }, promotedId);
  return {
    ...run,
    hand: [...run.hand.filter((card) => card.instanceId !== id), created.instance],
    nextCardSequence: created.nextCardSequence,
    pendingChoice: null,
  };
}
